import { get } from 'api/request';
import { WAFFLE_URL } from 'api/routes';
import { TWaffle } from './types';

export const apiWaffle = (): Promise<TWaffle> => get(WAFFLE_URL);
